import React, { Ref } from 'react'

import { Popover } from '@mui/material'

import DateCalendar, {
  DateCalendarProps
} from 'components_new/atoms/DateCalendar'

interface DatePopoverProps {
  anchorEl: HTMLElement | null
  closeOnSelect?: boolean
  DateCalendarProps: Omit<DateCalendarProps, 'value'>
  onClose: () => void
  open: boolean
  paperRef?: Ref<HTMLElement>
  value: DateCalendarProps['value']
}

/**
 * A date calendar in a popover below its anchor.
 */
const DatePopover = (props: DatePopoverProps) => {
  const {
    anchorEl,
    closeOnSelect,
    DateCalendarProps,
    onClose,
    open,
    paperRef,
    value
  } = props

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      onClose={onClose}
      open={open}
      disableAutoFocus={true}
      disableEnforceFocus={true}
      disableRestoreFocus={true}
      PaperProps={{ ref: paperRef, tabIndex: -1 }}
      transformOrigin={{ horizontal: 0, vertical: -4 }}
    >
      <DateCalendar
        value={value}
        {...DateCalendarProps}
        onChange={
          closeOnSelect
            ? (date) => {
                DateCalendarProps.onChange?.(date)
                onClose()
              }
            : DateCalendarProps.onChange
        }
      />
    </Popover>
  )
}

export default DatePopover
